import { Element } from "@craftjs/core";

import { FormCheckboxBlock, FormConsentBlock, FormContinueButtonBlock, FormDateBlock, FormDateTripleSelectBlock, FormDOBBlock, FormFeedbackMessageBlock, FormInputBlock, FormLabelBlock, FormRadioBlock, FormSelectBlock, FormPreviousButtonBlock, FormButtonsGridBlock, FormCheckBoxMultiBlock, FormRadioMultiBlock, FormTextAreaBlock, FormH1Block, FormH2Block, FormH3Block, FormH4Block, FormH5Block, FormH6Block } from "../..";

import { useFormFieldContext } from "./context";

function formInputLike(ComponentBlock) {
  return () => <>
    <Element is={FormLabelBlock} id='label' />
    <Element is={ComponentBlock} id='field' />
    <Element is={FormFeedbackMessageBlock} id='feedback' />
  </>
}

function formConsentComponent(ComponentBlock) {
  return () => {
    const { field: { field_component } } = useFormFieldContext()

    if (field_component === 'use_reg_consent') return null

    return <>
      <Element is={FormLabelBlock} id='label' />
      <Element is={ComponentBlock} id='field' />
    </>
  }
}

function formContinueButtonLike() {
  return () => {
    const { field: { label } } = useFormFieldContext()

    return <>
      <Element is={FormContinueButtonBlock} id='button' label={label} />
    </>
  }
}

function dobLike() {
  return () => <>
    <Element is={FormLabelBlock} id='label' />
    <Element is={FormDOBBlock} id='dob' />
    <Element is={FormFeedbackMessageBlock} id='feedback' />
  </>
}

function headingLike(FormHeadingBlock) {
  return () => <Element is={FormHeadingBlock} id='heading' />
}

export const customFields = new Proxy({}, {
  get(target, type) {
    if (!target[type]) {
      const FormInput = formInputLike(FormInputBlock)
      const FormSelect = formInputLike(FormSelectBlock)
      const FormCheckbox = formInputLike(FormCheckboxBlock)
      const FormDate = formInputLike(FormDateBlock)
      const FormDateTripleSelect = formInputLike(FormDateTripleSelectBlock)
      const FormRadio = formInputLike(FormRadioBlock)
      const FormButtonsGrid = formInputLike(FormButtonsGridBlock)
      const FormCheckBoxMulti = formInputLike(FormCheckBoxMultiBlock)
      const FormRadioMulti = formInputLike(FormRadioMultiBlock)
      const FormTextArea = formInputLike(FormTextAreaBlock)
      const FormH1 = headingLike(FormH1Block)
      const FormH2 = headingLike(FormH2Block)
      const FormH3 = headingLike(FormH3Block)
      const FormH4 = headingLike(FormH4Block)
      const FormH5 = headingLike(FormH5Block)
      const FormH6 = headingLike(FormH6Block)

      target[type] = {
        text: FormInput,
        select: FormSelect,
        number: FormInput,
        checkbox_unique: FormCheckbox,
        datepicker: FormDate,
        date_triple_select: FormDateTripleSelect,
        boolean: FormRadio,
        buttons_grid_boolean: FormButtonsGrid,
        buttons_grid: FormButtonsGrid,
        checkbox: FormCheckBoxMulti,
        radio: FormRadioMulti,
        password: FormInput,
        zipcode: FormInput,
        statelist: FormSelect,
        textarea: FormTextArea,
        h1: FormH1,
        h2: FormH2,
        h3: FormH3,
        h4: FormH4,
        h5: FormH5,
        h6: FormH6,
      }[type]
    }
    return target[type]
  },
})

export const fields = new Proxy({}, {
  get(target, key) {
    if (!target[key]) {
      const FormInput = formInputLike(FormInputBlock)
      const FormSelect = formInputLike(FormSelectBlock)
      const FormButton = formContinueButtonLike()
      const FormDOB = dobLike()

      const FormConsent = formConsentComponent(FormConsentBlock)

      target[key] = {
        first_name: FormInput,
        last_name: FormInput,
        email: FormInput,
        address1: FormInput,
        address2: FormInput,
        city: FormInput,
        state: FormSelect,
        zip: FormInput,
        phone: FormInput,
        submit: FormButton,
        dob: FormDOB,
        registration_consent: FormConsent,
        tcpa_consent: FormConsent,
        tcpa_consent_instructions: FormConsent,
        recording_consent: FormConsent,
        password: FormInput,
        password_confirmation: FormInput,
        label: () => <Element is={FormLabelBlock} id='label-block' />,
        previous_step_button: () => <Element is={FormPreviousButtonBlock} id='previous-step-button-block' />,
      }[key]
    }
    return target[key]
  },
})
